<template>
  <BaseCustomizeMetal componentCode="T" />
</template>
<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalT",
  components: {
    BaseCustomizeMetal,
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 112px;
    left: 119px;
    transform: scale(0.95);
    @include betweenTableTablePro {
      transform: scale(0.75);
      top: 72px;
      left: 69px;
    }
    @include table {
      transform: scale(0.65);
      top: 54px;
      left: 45px;
    }
    @include phone {
      transform: scale(0.6);
      top: 44px;
      left: 29px;
    }
  }
  .templeName {
    height: 33px;
    width: 235px;
    .textContainer {
      width: 235px;
    }
  }
  .godName {
    width: 260px;
    height: 58px;
    margin-top: 3px;
    margin-bottom: 8px;
    .textContainer {
      width: 260px;
    }
  }
  .gift {
    width: 171px;
    height: 33px;
    .textContainer {
      width: 171px;
    }
  }
}
</style>
